import React__default from 'react';
import { u as useStrings } from './responsive-b521ac2b.js';
import { S as Screen } from './DocumentScreenSkeleton-1f9d5851.js';

function usePageTitle(...title) {
    const { app: strings } = useStrings();
    React__default.useEffect(() => {
        const previousTitle = document.title;
        const parts = [strings.name]; // App name.
        for (const part of title) {
            if (part !== undefined) {
                parts.push(part);
            }
        }
        document.title = parts.reverse().join(' | ');
        return () => {
            document.title = previousTitle;
        };
    }, [title, strings.name]);
}

var faChevronRight = {};

var hasRequiredFaChevronRight;

function requireFaChevronRight () {
	if (hasRequiredFaChevronRight) return faChevronRight;
	hasRequiredFaChevronRight = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'chevron-right';
		var width = 320;
		var height = 512;
		var ligatures = [];
		var unicode = 'f054';
		var svgPathData = 'M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faChevronRight = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faChevronRight));
	return faChevronRight;
}

var faChevronRightExports = requireFaChevronRight();

const NotFoundScreen = () => {
    const { errors: strings } = useStrings();
    return React__default.createElement(Screen, { className: "NotFoundScreen", errorText: strings.pageNotFound });
};

var faChevronLeft = {};

var hasRequiredFaChevronLeft;

function requireFaChevronLeft () {
	if (hasRequiredFaChevronLeft) return faChevronLeft;
	hasRequiredFaChevronLeft = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'chevron-left';
		var width = 320;
		var height = 512;
		var ligatures = [];
		var unicode = 'f053';
		var svgPathData = 'M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faChevronLeft = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faChevronLeft));
	return faChevronLeft;
}

var faChevronLeftExports = requireFaChevronLeft();

var faEdit = {};

var hasRequiredFaEdit;

function requireFaEdit () {
	if (hasRequiredFaEdit) return faEdit;
	hasRequiredFaEdit = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'edit';
		var width = 576;
		var height = 512;
		var ligatures = [];
		var unicode = 'f044';
		var svgPathData = 'M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faEdit = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faEdit));
	return faEdit;
}

var faEditExports = requireFaEdit();

var faFile = {};

var hasRequiredFaFile;

function requireFaFile () {
	if (hasRequiredFaFile) return faFile;
	hasRequiredFaFile = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'file';
		var width = 384;
		var height = 512;
		var ligatures = [];
		var unicode = 'f15b';
		var svgPathData = 'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faFile = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faFile));
	return faFile;
}

var faFileExports = requireFaFile();

export { NotFoundScreen as N, faEditExports as a, faFileExports as b, faChevronLeftExports as c, faChevronRightExports as f, usePageTitle as u };
